type PaginationProps = {
  current: number;
  total: number;
  onChange: (page: number) => void;
};

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, index) => index + 1);

  return (
    <div className="mt-8 flex items-center justify-center gap-2">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line" />
      </button>
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`h-9 min-w-9 rounded-md px-3 text-sm font-medium transition-colors ${
            page === current
              ? 'bg-primary-500 text-background-50'
              : 'border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-700'
          }`}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}